import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateCustomFieldValue($companyId: ID!, $id: ID!, $attributes: CustomFieldValueAttributes!) {
    updateCustomFieldValue(companyId: $companyId, id: $id, attributes: $attributes) {
      customFieldValue {
        id
        ...UpdatedCustomFieldValues
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedCustomFieldValues on CustomFieldValue {
    id
    value
  }
`
